import React from 'react';
import { IYourShiftsSidebarPanel } from './interfaces';
import { ContentPanel } from '@components/ContentPanel';
import { Button, Stack, Typography } from '@mui/material';

export const YourShiftsSidebarPanel: React.FC<
  IYourShiftsSidebarPanel
> = ({}): JSX.Element => {
  return (
    <ContentPanel borderRadius="none" title="Jouw diensten">
      <Stack spacing={0.5}>
        <Typography variant="body2">
          Ingeschreven: <strong>2</strong>
        </Typography>
        <Typography variant="body2">
          Volgende: <strong>Bar – za 09:00</strong>
        </Typography>
      </Stack>

      <Button size="small" variant="outlined" fullWidth sx={{ mt: 2 }}>
        Mijn diensten bekijken
      </Button>
    </ContentPanel>
  );
};
